import { prop } from '@lib/style/theme';
import { unitStrict } from '@lib/style/unit';
import { classList } from '@lib/utils';
import { createMemo } from '@packages/react';
import { applyRef } from '@packages/react/applyRef';
import { ColorType } from '@packages/style/colors';
import { transparentize } from 'polished';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

export interface BackdropBlurProps {
    size?: number | string;
    children?: any;
    component?: any;
    className?: string;
    saturate?: string;
    tintColor?: ColorType;
    tintOpacity?: number;
}

export const BackdropBlur = styled(
    createMemo<BackdropBlurProps>(
        forwardRef(
            (
                {
                    children,
                    className,
                    size,
                    tintColor,
                    tintOpacity,
                    component: Component,

                    ...rest
                },
                ref,
            ): any => {
                applyRef(rest, ref);

                return Component ? (
                    <Component className={className} {...rest}>
                        {children}
                    </Component>
                ) : (
                    React.Children.map(children, (child: any) => ({
                        ...child,
                        props: {
                            ...child.props,
                            ...rest,
                            className: classList(child.props.className, className),
                        },
                    }))
                );
            },
        ),
        {
            displayName: 'BackdropBlur',
        },
    ),
)`
    & {
        background-color: ${({ tintColor, tintOpacity }) =>
            transparentize(1 - (tintOpacity ?? 1), tintColor ?? '#fff')};
        backdrop-filter: saturate(${prop('saturate', '0%')}) blur(${prop('size', 0, unitStrict)});
    }
`;

BackdropBlur.defaultProps = {
    tintColor: '#fff',
    tintOpacity: 1,
    saturate: '0%',
    size: 0,
};
